"use strict";

exports.__esModule = true;
exports.HistoricalPartCountContext = void 0;
var _Utils = require("../../../Utils");
var _HistoricalPartCountController = require("./HistoricalPartCountController");
/**
 * Provides an historical part count context to consumers
 */
var HistoricalPartCountContext = exports.HistoricalPartCountContext = (0, _Utils.createEnhancedContext)({
  propName: "historicalPartCounts",
  defaultController: _HistoricalPartCountController.HistoricalPartCountController
});